import React, { useEffect, useState } from "react";
import { Typography, Button, Box, Divider, InputBase, IconButton } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import RefreshOutlinedIcon    from "@material-ui/icons/RefreshOutlined";
import ArrowUpwardIcon        from "@material-ui/icons/ArrowUpward";
import ModuleCard, { MODULES } from "./ResourceModuleCard";
import FlashOnIcon from '@material-ui/icons/FlashOn';

const BLUE         = "#3B82F6";
const GREEN        = "#22c27a";
const GREEN_DIM    = "rgba(34,194,122,0.1)";
const GREEN_BORDER = "rgba(34,194,122,0.3)";
const BORDER       = "#dde0ee";
const TEXT         = "#1a1d2e";
const MUTED        = "#7b80a0";

const useStyles = makeStyles((theme) => ({
  sectionTitle: {
    display: "flex",
    alignItems: "center",
    gap: 7,
    fontSize: 13,
    fontWeight: 600,
    color: TEXT,
    "& svg": { fontSize: 18 },
  },
  reuploadBtn: {
    marginLeft: "auto",
    padding: "2px 6px",
    fontSize: 11,
    color: MUTED,
    textTransform: "none",
    minWidth: 0,
    "&:hover": { color: BLUE, background: "transparent" },
  },
  banner: {
    display: "flex",
    alignItems: "center",
    gap: 9,
    background: GREEN_DIM,
    border: `0.5px solid ${GREEN_BORDER}`,
    borderRadius: 6,
    padding: "9px 12px",
  },
  bannerIcon: { color: GREEN, fontSize: 18, flexShrink: 0 },
  bannerName: { fontSize: 12, fontWeight: 500, color: TEXT },
  bannerSub:  { fontSize: 11, color: MUTED },
  promptRow: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    border: `0.5px solid ${BORDER}`,
    borderRadius: 6,
    padding: "7px 10px",
  },
  promptInput: { flex: 1, fontSize: 12, color: TEXT },
  sendBtn: {
    background: BLUE,
    color: "#fff",
    width: 26,
    height: 26,
    borderRadius: 5,
    padding: 0,
    "&:hover": { background: "#2563eb" },
    "& svg": { fontSize: 14 },
  },
  emptyContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },
  actionCard: {
    maxWidth: '100%',
    width: '100%',
    padding: theme.spacing(3),
    backgroundColor: '#f8fafc',
    borderRadius: 16,
    border: '1px dashed #e2e8f0',
    boxShadow: '0 4px 12px rgba(0,0,0,0.03)',
  },
  aiButton: {
    marginTop: theme.spacing(3),
    backgroundColor: '#34445c', // Your brand slate
    color: '#fff',
    fontWeight: 700,
    textTransform: 'none',
    padding: '10px 24px',
    borderRadius: 8,
    '&:hover': {
      backgroundColor: '#1e293b',
    },
  },
  divider: {
    margin: theme.spacing(2, 0),
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    color: '#94a3b8',
    '&::before, &::after': {
      content: '""',
      flex: 1,
      height: 1,
      backgroundColor: '#e2e8f0',
    },
    '& span': {
      padding: '0 10px',
      fontSize: '0.7rem',
      fontWeight: 700,
      textTransform: 'uppercase',
    }
  }
}));

const summaryMap = {
  "system_model": "system_model_summary",
  "db_profile": "database_summary",
  "views": "view_summary",
  "transactions": "transaction_summary",
  "simulation": "testsuite_summary"
}

export default function ResultsStage({ lastFileName, onReset, summary, setActiveStep, setAutoGenerate, clusterletsList }) {
  const cls = useStyles();
  const [structuredSummary, setStructuredSummary] = useState();

  const onAutoGenerate = () => {
    setActiveStep('system_model')
    setTimeout(() => setAutoGenerate(true) ,500)
  }

  useEffect(() => {
    if(summary){
      const structure = MODULES.map(module => ({
        ...module,
        content: summary?.[summaryMap[module.key]]
      }))
      setStructuredSummary(structure);
    }
  },[summary])

  console.log({clusterletsList})

  return (
    <>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <div className={cls.sectionTitle}>
          <CheckCircleOutlineIcon style={{ color: GREEN }} />
          <span>Analysis complete</span>
        </div>
      </Box>

      <div className={cls.banner}>
        <CheckCircleOutlineIcon className={cls.bannerIcon} />
        <div>
          <Typography className={cls.bannerName}>{lastFileName}</Typography>
          <Typography className={cls.bannerSub}>Context extracted</Typography>
        </div>
      </div>

      {
        clusterletsList.length <= 1 &&
        <Box className={cls.emptyContainer}>
          <Box className={cls.actionCard}>
            <img src="/node_icons/ai.png" style={{width: '3rem'}} alt="hyperblox agent"/>

            <Typography variant="h6" style={{ fontWeight: 800, color: '#1e293b' }}>
              Generate System Model
            </Typography>

            <Button 
              variant="contained" 
              className={cls.aiButton}
              onClick={onAutoGenerate}
              startIcon={<FlashOnIcon style={{ color: '#ffea00' }} />}
            >
              Auto-Generate From uploaded file
            </Button>

          </Box>
        </Box>
      }

      <div>
        {structuredSummary?.map((m, idx) => (
          <ModuleCard key={m.key} mod={m} defaultOpen={idx === 0} />
        ))}
      </div>
    </>
  );
}